import { Component } from '@angular/core';

/** Displays an router-outlet to display views */
@Component({
  selector: 'app-content-wrapper',
  templateUrl: './content-wrapper.component.html',
  styleUrls: ['./content-wrapper.component.scss']
})
export class ContentWrapperComponent {

  /** Inits component */
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/content-wrapper/content-wrapper.component.ts